module.exports = __webpack_public_path__ + "img/1541015275.62d41959.jpg";